<div class="top-nav">
  <div class="logo">
    <a href="/master/dashboard">
      <img src="../../../assets/images/ikoo-new-logo.png" alt="" />
    </a>
  </div>
  <div class="top-nav-dropdown-area">
    <div class="top-nav-dropdown">
      <button
        class="dropdown-btn username"
        style="background: none"
        (click)="adminClick($event)"
      >
        Welcome {{ userName }}
      </button>
      <div class="dropdown-container" *ngIf="showAdminDrop">
        <span (click)="logOut($event)">
          <mat-icon>exit_to_app</mat-icon> Log Out
        </span>
      </div>
    </div>
    <!-- <div class="profile-icon-container">
      <a class="profile-icon-link">
        <mat-icon class="profile-icon">account_circle</mat-icon>
      </a>
    </div> -->
    <div style="display: flex; align-items: center">
      <img
        src="../../../assets/images/language-icon.png"
        alt=""
        style="height: 25px; width: 25px"
      />
    </div>
  </div>
</div>
